<template lang="pug">
  v-dialog(v-model="show" persistent content-class="video" max-width="650")
    v-card.guide-modal
      .close
        v-btn(icon dark @click="close(false)")
          v-icon(color="#0855C4") close
      youtube(
        :video-id="videoId"
        ref="youtube"
        width="100%"
        resize=true
        )
</template>
<script>

export default {
  props: [
    'show',
    'videoId'
  ],
  methods: {
    close (item) {
      try {
        let player = this.$refs.youtube.player
        this.$emit('closeDialogVideo', item)
        player.stopVideo()
      } catch (e) {}
    }
  }
}
</script>
<style scoped>
.guide-modal {
  border-radius: 5px;
  padding: 15px;
}

.guide-modal .close {
  display: flex;
  justify-content: end;
  align-items: flex-end;
  padding: 15px;
}

.guide-modal .close .v-btn {
  width: auto;
  height: auto;
  padding: 5px;
  position: absolute;
  top: 0;
  right: 0;
}

.guide-modal .v-card__title {
  color: var(--first-brand-color);
  font-size: 18px;
  justify-content: center;
  line-height: normal;
  padding: 0 0 23px;
  text-align: center;
}

.guide-modal .v-card__text {
  padding: 0;
}

.guide-modal .card-tutorial {
  display: flex;
  justify-content: center;
  gap: 13px;
}

.guide-modal .card-tutorial .number {
  min-width: 40px;
  width: 40px;
  height: 40px;
  border: 1px solid var(--first-brand-color);
  border-radius: 50%;
  color: var(--first-brand-color);
  font-size: 20px;
  line-height: normal;
}

.guide-modal .card-tutorial .detail {
  width: 80%;
}

.guide-modal .card-tutorial .detail h3,
.guide-modal .card-tutorial .detail p {
  color: var(--text-color);
  font-size: 16px;
  line-height: normal;
}

.guide-modal .card-tutorial .detail h3 {
  margin-bottom: 3px;
}

.guide-modal .card-tutorial .detail p {
  margin-bottom: 23px;
}

.guide-modal .card-tutorial .preview img {
  display: flex;
  width: 100%;
  border-radius: 10px;
}

.guide-modal .v-card__text iframe {
  width: 100%;
  height: 185px;
}

@media screen and (min-width: 1024px) {
  .guide-modal .v-card__text iframe {
    height: 350px;
  }
  .v-dialog.video {
    width: 100% !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/login/DialogVideo.vue